import { render } from "./NotaChipComponent.vue?vue&type=template&id=0d902c5f&scoped=true"
import script from "./NotaChipComponent.vue?vue&type=script&lang=js"
export * from "./NotaChipComponent.vue?vue&type=script&lang=js"

import "./NotaChipComponent.vue?vue&type=style&index=0&id=0d902c5f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d902c5f"]])

export default __exports__